import { inject, Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { ApiRoutesService } from "../api-routes.service";
import { PageModel } from "../../models/page.model";
import { Hardware } from "../../models/hardware.model";
import { SortDirection } from "@angular/material/sort";

@Injectable({
  providedIn: "root"
})
export class AdminHardwareService {

  readonly #httpClient = inject(HttpClient);
  readonly #apiRoutes = inject(ApiRoutesService);

  public findAll(page: number, pageSize: number, search: string, sort: string, direction: SortDirection): Observable<PageModel<Hardware>> {
    const params = new HttpParams()
      .set("page", page.toString())
      .set("pageSize", pageSize.toString())
      .set("search", search)
      .set("sort", sort)
      .set("direction", direction);

    return this.#httpClient.get<PageModel<Hardware>>(this.#apiRoutes.hardware(true), { params });
  }

  public getAvailableHardware(): Observable<Hardware[]> {
    return this.#httpClient.get<Hardware[]>(this.#apiRoutes.hardware(true) + "/available");
  }

  public createHardware(hardware: Hardware) {
    return this.#httpClient.post<Hardware>(this.#apiRoutes.hardware(true), hardware);
  }

  public updateHardware(hardwareId: string, updateData: Hardware) {
    return this.#httpClient.patch<Hardware>(`${this.#apiRoutes.hardware(true)}/${hardwareId}`, updateData);
  }

  public deleteHardware(hardwareId: string) {
    return this.#httpClient.delete<void>(`${this.#apiRoutes.hardware(true)}/${hardwareId}`);
  }


}
